/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RecordingFileFormat {
}

export enum RecordingFileFormat_Enum {
  FILE_FORMAT_MP4 = 0,
  FILE_FORMAT_MPEGTS = 1,
  UNRECOGNIZED = -1,
}

export function recordingFileFormat_EnumFromJSON(object: any): RecordingFileFormat_Enum {
  switch (object) {
    case 0:
    case "FILE_FORMAT_MP4":
      return RecordingFileFormat_Enum.FILE_FORMAT_MP4;
    case 1:
    case "FILE_FORMAT_MPEGTS":
      return RecordingFileFormat_Enum.FILE_FORMAT_MPEGTS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingFileFormat_Enum.UNRECOGNIZED;
  }
}

export function recordingFileFormat_EnumToJSON(object: RecordingFileFormat_Enum): string {
  switch (object) {
    case RecordingFileFormat_Enum.FILE_FORMAT_MP4:
      return "FILE_FORMAT_MP4";
    case RecordingFileFormat_Enum.FILE_FORMAT_MPEGTS:
      return "FILE_FORMAT_MPEGTS";
    case RecordingFileFormat_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRecordingFileFormat(): RecordingFileFormat {
  return {};
}

export const RecordingFileFormat = {
  encode(_: RecordingFileFormat, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RecordingFileFormat {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecordingFileFormat();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RecordingFileFormat {
    return {};
  },

  toJSON(_: RecordingFileFormat): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RecordingFileFormat>, I>>(base?: I): RecordingFileFormat {
    return RecordingFileFormat.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecordingFileFormat>, I>>(_: I): RecordingFileFormat {
    const message = createBaseRecordingFileFormat();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
